// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c0ce1da6","453":"5692dcba","732":"565c9180","977":"bcf54308"}[chunkId] + ".chunk.js";
};